import { render, staticRenderFns } from "./CPI-PPI.vue?vue&type=template&id=c8d92f08&"
import script from "./CPI-PPI.vue?vue&type=script&lang=ts&"
export * from "./CPI-PPI.vue?vue&type=script&lang=ts&"
import style0 from "./CPI-PPI.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports